import { useSnackbar } from "notistack";
import { ERROR_MSG } from "./constants";

const useToast = () => {
  const { enqueueSnackbar } = useSnackbar();

  return (msg = ERROR_MSG, variant = "error") =>
    enqueueSnackbar(msg, {
      variant,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center",
      },
    });
};

export default useToast;
